// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*General*/
:root {
  --color-navy: #0a1172;
  --color-navy-dark: #060b4a;
  --color-primary: #3b6cf4;
  --color-primary-hover: #2f58d0;
  --color-surface: #ffffff;
  --color-surface-muted: #f4f6fb;
  --color-border: #e3e8f2;
  --color-text: #1f2937;
  --color-text-muted: #5b6478;
  --shadow-sm: 0 2px 8px rgba(10, 17, 114, 0.08);
  --shadow-md: 0 8px 24px rgba(10, 17, 114, 0.12);
  --radius-md: 12px;
  --radius-lg: 16px;
}

* {
  box-sizing: border-box;
}

html {
  background: linear-gradient(180deg, #eef1fb 0%, #e8ecf8 100%);
}

body {
  font-family: 'Inter', 'Rubik', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: var(--color-text);
}

#root {
  min-height: 100vh;
}

.app-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-main {
  flex: 1 1;
  padding: 1.5rem 0 2.5rem;
}

.page-container {
  max-width: 960px;
}

.page-card,
.jumbotron {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: 2rem;
}

.page-card-header {
  margin-bottom: 1.5rem;
}

.page-eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--color-primary);
}

.page-card h1,
.jumbotron .display-4 {
  font-size: clamp(1.75rem, 3vw, 2.25rem);
  font-weight: 700;
  color: var(--color-navy-dark);
  margin-bottom: 0.75rem;
}

.page-lead,
.jumbotron .lead {
  color: var(--color-text-muted);
  font-size: 1.05rem;
  line-height: 1.6;
}

.btn-primary {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}

.btn-primary:hover,
.btn-primary:focus {
  background-color: var(--color-primary-hover);
  border-color: var(--color-primary-hover);
}

.btn-outline-primary {
  color: var(--color-primary);
  border-color: var(--color-primary);
}

.btn-outline-primary:hover {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}

.form-control:focus {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 0.2rem rgba(59, 108, 244, 0.15);
}

/* Site header */

.site-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: rgba(6, 11, 74, 0.96);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: var(--shadow-sm);
}

.site-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 68px;
}

.site-header-top {
  display: contents;
}

.site-brand {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  color: #ffffff;
  text-decoration: none;
  font-weight: 700;
  font-size: 1.2rem;
  flex-shrink: 0;
}

.site-brand:hover {
  color: #ffffff;
  text-decoration: none;
  opacity: 0.92;
}

.site-brand-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.12);
}

.site-nav-toggle {
  display: none;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  padding: 0.35rem 0.55rem;
  background: transparent;
  cursor: pointer;
}

.site-nav {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.site-nav-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
}

.site-nav-link {
  color: rgba(255, 255, 255, 0.88);
  text-decoration: none;
  padding: 0.5rem 0.85rem;
  border-radius: 8px;
  font-weight: 500;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.site-nav-link:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
  text-decoration: none;
}

.site-nav-link-active {
  color: #ffffff;
  background: rgba(59, 108, 244, 0.35);
}

.site-nav-logout {
  margin-left: 0.75rem;
  padding: 0.45rem 0.9rem;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  background: transparent;
  color: #ffffff;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.site-nav-logout:hover {
  background: rgba(255, 255, 255, 0.12);
}

@media (max-width: 767px) {
  .site-header-inner {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    min-height: 68px;
  }

  .site-header-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 68px;
    flex-shrink: 0;
  }

  .site-nav-toggle {
    display: inline-flex;
    flex-shrink: 0;
  }

  .site-nav {
    display: none;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    margin: 0;
    padding-top: 0.75rem;
    border-top: 1px solid rgba(255, 255, 255, 0.12);
  }

  .site-nav.site-nav-open {
    display: flex;
  }

  .site-nav-links {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }

  .site-nav-link {
    text-align: left;
  }

  .site-nav-logout {
    margin: 0.75rem 0 1.25rem;
    width: 100%;
  }
}

/* Site footer */

.site-footer {
  margin-top: auto;
  background: var(--color-navy-dark);
  color: rgba(255, 255, 255, 0.85);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.site-footer-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 0.5rem;
  min-height: 96px;
  padding: 1.25rem 0;
}

.site-footer-logo {
  font-weight: 600;
}

.site-footer-copy {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.65);
}

.site-footer-nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem 1.5rem;
}

.site-footer-nav a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-weight: 500;
}

.site-footer-nav a:hover {
  color: #ffffff;
  text-decoration: underline;
}

/* Legal pages */

.legal-page section {
  margin-bottom: 1.75rem;
}

.legal-page h2 {
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--color-navy-dark);
  margin-bottom: 0.75rem;
}

.legal-page p,
.legal-page li {
  color: var(--color-text-muted);
  line-height: 1.7;
}

.legal-page ul {
  padding-left: 1.25rem;
}

.legal-page a {
  color: var(--color-primary);
  font-weight: 500;
}

.legal-page a.btn-primary,
.legal-page a.btn-primary:hover,
.legal-page a.btn-primary:focus,
.legal-page a.btn-outline-primary:hover,
.legal-page a.btn-outline-primary:focus {
  color: #ffffff;
}

.contact-form {
  max-width: 36rem;
}

.contact-message {
  min-height: 10rem;
  resize: vertical;
}

.contact-honeypot {
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.legal-page-footer {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--color-border);
}

.about-callout {
  background: var(--color-surface-muted);
  border: 1px solid var(--color-border);
  border-left: 4px solid var(--color-primary);
  border-radius: var(--radius-md);
  padding: 1.25rem 1.4rem;
  margin-bottom: 1.75rem;
}

.about-callout h2 {
  margin-top: 0;
}

.about-callout p:last-child {
  margin-bottom: 0;
}

.about-highlights {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

@media (min-width: 768px) {
  .about-highlights {
    grid-template-columns: 1fr 1fr;
  }
}

.about-highlights .home-feature-item {
  height: 100%;
}

.about-steps {
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: about-step;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.about-steps li {
  position: relative;
  padding: 1rem 1.15rem 1rem 3.35rem;
  background: var(--color-surface-muted);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  color: var(--color-text-muted);
  line-height: 1.65;
}

.about-steps li::before {
  counter-increment: about-step;
  content: counter(about-step);
  position: absolute;
  left: 0.9rem;
  top: 1rem;
  width: 1.7rem;
  height: 1.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(59, 108, 244, 0.12);
  color: var(--color-primary);
  font-weight: 700;
  font-size: 0.9rem;
}

.about-steps strong {
  color: var(--color-navy-dark);
}

.about-faq h3 {
  font-size: 1.02rem;
  font-weight: 600;
  color: var(--color-navy-dark);
  margin: 1.35rem 0 0.45rem;
}

.about-cta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.about-cta .btn {
  margin-bottom: 0;
}

.about-cta-note {
  margin: 0;
  font-size: 0.95rem;
}


/*Transaction*/
#validtype {
  display: flex;
  justify-content: center;
}

#transac_list {
  background-color: #F0F0F0
}

/* Historique */

.historique-calendar-card {
  text-align: center;
}

.historique-calendar-wrap {
  display: flex;
  justify-content: center;
}

.historique-calendar-wrap .rdp-root {
  --rdp-accent-color: var(--color-primary);
  --rdp-accent-background-color: rgba(59, 108, 244, 0.12);
  --rdp-day-height: 42px;
  --rdp-day-width: 42px;
  --rdp-day_button-height: 40px;
  --rdp-day_button-width: 40px;
  --rdp-selected-border: 2px solid var(--color-primary);
}

.historique-week-selected .rdp-day_button {
  background: rgba(59, 108, 244, 0.18);
  color: var(--color-navy-dark);
  font-weight: 600;
}

.historique-calendar-wrap .rdp-selected .rdp-day_button {
  background: transparent;
  color: inherit;
  font-weight: inherit;
  border: none;
}

.historique-week-label {
  margin: 1rem 0 0;
  padding: 0.65rem 1rem;
  display: inline-block;
  border-radius: 999px;
  background: rgba(59, 108, 244, 0.1);
  color: var(--color-navy-dark);
  font-weight: 600;
  font-size: 0.95rem;
}

.historique-view-toggle {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin: 1.25rem 0;
  flex-wrap: wrap;
}

.historique-view-btn {
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  color: var(--color-text-muted);
  border-radius: 999px;
  padding: 0.55rem 1.15rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.historique-view-btn:hover {
  border-color: var(--color-primary);
  color: var(--color-primary);
}

.historique-view-btn-active {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: #ffffff;
}

.historique-report-card {
  padding: 1.25rem;
}

.historique-report-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.historique-total-badge {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0.65rem 0.9rem;
  border-radius: var(--radius-md);
  background: rgba(59, 108, 244, 0.08);
  border: 1px solid rgba(59, 108, 244, 0.18);
}

.historique-total-label {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.historique-total-value {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--color-navy-dark);
}

.historique-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
}

.historique-table {
  margin-bottom: 0;
  background: var(--color-surface);
}

.historique-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--color-navy-dark);
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.12);
  white-space: nowrap;
  font-size: 0.85rem;
  font-weight: 600;
}

.historique-table tbody td {
  vertical-align: middle;
  font-size: 0.9rem;
  color: var(--color-text);
  border-color: var(--color-border);
}

.historique-table tbody tr:nth-child(even) {
  background: var(--color-surface-muted);
}

.historique-table tbody tr:hover {
  background: rgba(59, 108, 244, 0.06);
}

.historique-table tfoot td {
  background: var(--color-surface-muted);
  font-weight: 600;
  border-top: 2px solid var(--color-border);
}

.historique-notes-cell {
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.historique-delete-btn {
  padding: 0.2rem 0.45rem;
}

.historique-empty-state {
  text-align: center;
  padding: 2.5rem 1rem;
  color: var(--color-text-muted);
}

.historique-empty-icon {
  display: block;
  font-size: 2rem;
  margin-bottom: 0.75rem;
  color: var(--color-primary);
}

.historique-loading {
  margin: 0;
  padding: 2rem 0;
  text-align: center;
}

@media (max-width: 767px) {
  .historique-calendar-wrap .rdp-root {
    --rdp-day-height: 36px;
    --rdp-day-width: 36px;
    --rdp-day_button-height: 34px;
    --rdp-day_button-width: 34px;
  }

  .historique-report-header {
    flex-direction: column;
  }

  .historique-total-badge {
    align-items: flex-start;
  }
}

/* Transaction */

.transaction-page,
.historique-page {
  max-width: 1100px;
  padding-bottom: 1rem;
}

.transaction-header,
.historique-header {
  margin-bottom: 1.75rem;
}

.transaction-subtitle,
.historique-subtitle {
  margin: 0;
  color: var(--color-text-muted);
}

.transaction-section-title,
.historique-section-title {
  margin: 0 0 0.35rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-navy-dark);
}

.transaction-section-heading {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
}

.transaction-section-heading .transaction-section-title {
  margin: 0;
}

.transaction-help-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.55rem;
  height: 1.55rem;
  padding: 0;
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: var(--color-surface-muted);
  color: var(--color-primary);
  font-size: 0.85rem;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}

.transaction-help-btn:hover,
.transaction-help-btn:focus {
  background: rgba(59, 108, 244, 0.12);
  border-color: var(--color-primary);
  outline: none;
}

.shortcut-help-overlay {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: rgba(6, 11, 74, 0.45);
}

.shortcut-help-dialog {
  width: min(640px, 100%);
  max-height: min(80vh, 720px);
  display: flex;
  flex-direction: column;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: 1.25rem 1.35rem 1.35rem;
}

.shortcut-help-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.shortcut-help-header h3 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--color-navy-dark);
}

.shortcut-help-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  background: transparent;
  color: var(--color-text-muted);
  cursor: pointer;
}

.shortcut-help-close:hover {
  background: var(--color-surface-muted);
  color: var(--color-navy-dark);
}

.shortcut-help-status,
.shortcut-help-error {
  margin: 0;
  color: var(--color-text-muted);
}

.shortcut-help-error {
  color: #b91c1c;
}

.shortcut-help-table-wrap {
  overflow: auto;
}

.transaction-section-hint,
.historique-section-hint {
  margin: 0 0 1.25rem;
  color: var(--color-text-muted);
  font-size: 0.9rem;
}

.transaction-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem;
  margin-bottom: 1.25rem;
}

.transaction-form-card {
  height: 100%;
  margin-bottom: 0;
}

.transaction-form-card-wide {
  margin-bottom: 1.25rem;
}

.transaction-input-row {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 0.75rem;
}

.transaction-input-row-no-status {
  grid-template-columns: 1fr auto;
}

.transaction-status-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 999px;
  font-size: 1.1rem;
}

.transaction-status-icon-valid {
  color: #15803d;
  background: rgba(21, 128, 61, 0.1);
}

.transaction-status-icon-invalid {
  color: #b91c1c;
  background: rgba(185, 28, 28, 0.08);
}

.transaction-desc-preview {
  margin-bottom: 0.75rem;
  background: var(--color-surface-muted);
  color: var(--color-text-muted);
  font-size: 0.9rem;
}

.transaction-field {
  margin-bottom: 1rem;
}

.transaction-field label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--color-navy-dark);
}

.transaction-field-inline {
  max-width: 180px;
}

.transaction-field-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.transaction-field-full {
  grid-column: 1 / -1;
}

.transaction-code-fields {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.transaction-code-line {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  min-width: 0;
}

.transaction-code-line .transaction-code-input {
  flex: 1 1;
  min-width: 0;
}

.transaction-code-line-no-status .transaction-code-input {
  width: 100%;
}

.transaction-modif-select {
  width: 100%;
  min-width: 0;
}

@media (min-width: 992px) {
  .transaction-code-fields {
    grid-template-columns: minmax(0, 1fr) minmax(160px, auto);
    align-items: center;
  }

  .transaction-modif-select {
    width: auto;
    min-width: 160px;
  }
}

.transaction-qte-input,
.transaction-code-input {
  max-width: 140px;
}

.transaction-success-banner {
  margin-bottom: 1rem;
  padding: 0.65rem 0.85rem;
  border-radius: var(--radius-md);
  background: rgba(21, 128, 61, 0.1);
  border: 1px solid rgba(21, 128, 61, 0.2);
  color: #166534;
  font-size: 0.9rem;
  font-weight: 600;
}

.transaction-submit-row {
  display: flex;
  justify-content: center;
  padding-top: 0.25rem;
}

.transaction-loading {
  text-align: center;
  padding: 2rem 0;
}

@media (max-width: 991px) {
  .transaction-form-grid,
  .transaction-field-grid {
    grid-template-columns: 1fr;
  }

  .transaction-input-row {
    grid-template-columns: auto 1fr;
  }

  .transaction-input-row-no-status {
    grid-template-columns: 1fr;
  }

  .transaction-input-row-no-status .transaction-modif-select,
  .transaction-input-row .transaction-modif-select,
  .transaction-input-row #inputModif {
    grid-column: 1 / -1;
  }

  .transaction-qte-input,
  .transaction-code-input,
  .transaction-field-inline {
    max-width: none;
  }

  .transaction-input-row .transaction-qte-input {
    grid-column: 1 / -1;
  }
}


/*Auth page*/

.auth-actions-box {
  width: 100%;
  max-width: 320px;
  padding: 1.75rem;
  background: var(--color-surface-muted);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
}

.auth-actions-box-secondary {
  margin-top: 1.5rem;
  background: #f8f9fc;
}

.auth-actions-title {
  font-size: 1.35rem;
  font-weight: 600;
  color: var(--color-navy-dark);
  margin-bottom: 0.5rem;
  text-align: center;
}

.auth-actions-subtitle {
  font-size: 0.95rem;
  color: #5a6275;
  text-align: center;
  margin-bottom: 1.25rem;
}

.auth-actions-btn {
  margin-bottom: 0.75rem;
}

.auth-actions-btn:last-child {
  margin-bottom: 0;
}

.auth-actions-link {
  display: block;
  width: 100%;
  margin-top: 0.5rem;
  padding: 0.25rem 0;
  font-size: 0.9rem;
  color: #000066;
  text-align: center;
  text-decoration: none;
}

.auth-actions-link:hover {
  color: #4688F4;
  text-decoration: underline;
}

.auth-footer-links {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e6ef;
  text-align: center;
}

.auth-footer-links p {
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
  color: #5a6275;
}

.auth-footer-links p:last-child {
  margin-bottom: 0;
}

.auth-footer-links a {
  color: #000066;
  font-weight: 500;
}

.auth-footer-links a:hover {
  color: #4688F4;
}

.auth-inline-link {
  font-size: 0.9rem;
  color: #000066;
  font-weight: 500;
}

.auth-inline-link:hover {
  color: #4688F4;
}

#logbutton {
  color: rgb(255, 255, 255);
  background-color: #4688F4;
  text-align: center;
  text-decoration: none;
  height: 37px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-right: 16px;
  padding-left: 16px;
  border: none;
  cursor: pointer;
}

.auth-form .form-group {
  margin-bottom: 1rem;
}

#btnbox {
  min-height: 25vh;
  display: flex;
  background: transparent;
  justify-content: center;
  box-shadow: none;
  border: none;
  padding: 0;
}

.home-landing {
  padding: 2rem;
}

.home-landing-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 2rem;
}

.home-landing-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 0.75rem;
  border-radius: 14px;
  background: rgba(59, 108, 244, 0.12);
  color: var(--color-primary);
  font-size: 1.5rem;
}

.home-landing-header h1 {
  margin: 0;
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 700;
  color: var(--color-navy-dark);
}

.home-landing-lead {
  max-width: 36rem;
  margin: 0.85rem 0 0;
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.5;
  color: var(--color-navy);
}

.home-landing-sublead {
  max-width: 38rem;
  margin: 0.5rem 0 0;
  font-size: 1.02rem;
  line-height: 1.6;
  color: var(--color-text-muted);
}

.home-landing-auth {
  margin-bottom: 0;
}

.home-landing-features {
  margin-top: 0;
}

@media (max-width: 991px) {
  .home-landing-features {
    margin-top: 2rem;
  }

  .auth-actions-box {
    max-width: 100%;
  }
}

@media (min-width: 992px) {
  .home-landing-content {
    align-items: center;
  }

  .home-landing-features {
    padding-right: 1rem;
  }

  .home-landing-auth {
    padding-left: 1rem;
  }
}

.home-features {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.home-feature-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.1rem 1.15rem;
  background: var(--color-surface-muted);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.home-feature-item:hover {
  box-shadow: var(--shadow-sm);
  transform: translateY(-1px);
}

.home-feature-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: rgba(59, 108, 244, 0.12);
  color: var(--color-primary);
  font-size: 1.1rem;
}

.home-feature-content h3 {
  margin: 0 0 0.35rem;
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--color-navy-dark);
  font-family: inherit;
}

.home-feature-content p {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.55;
  color: var(--color-text-muted);
  font-family: inherit;
}

#logoGoogle {
  background-color: rgb(255, 255, 255);
  display: flex;
  float: left;
}

/* Home KPIs */

.home-dashboard-page,
.dashboard-page {
  max-width: 1180px;
}

.home-dashboard-header,
.dashboard-page-header {
  margin-bottom: 1.75rem;
}

.home-dashboard-header h1,
.dashboard-page-header h1 {
  margin: 0 0 0.4rem;
  font-size: clamp(1.85rem, 3vw, 2.35rem);
  font-weight: 700;
  color: var(--color-navy-dark);
}

.home-dashboard-header .page-lead,
.dashboard-page-header .page-lead {
  margin: 0;
}

.home-kpi-section {
  margin-bottom: 2rem;
}

.home-kpi-section-head {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  margin-bottom: 1rem;
}

.home-kpi-section-head h2 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--color-navy-dark);
}

.home-kpi-section-head p {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.95rem;
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}

.kpi-card {
  position: relative;
  overflow: hidden;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  padding: 1.15rem 1.2rem 1.2rem;
  min-height: 154px;
  display: flex;
  flex-direction: column;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.kpi-card::before {
  content: '';
  position: absolute;
  inset: 0 auto 0 0;
  width: 4px;
  background: var(--kpi-accent);
}

.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.kpi-card-blue {
  --kpi-accent: #3b6cf4;
  --kpi-accent-soft: rgba(59, 108, 244, 0.12);
}

.kpi-card-indigo {
  --kpi-accent: #4f46e5;
  --kpi-accent-soft: rgba(79, 70, 229, 0.12);
}

.kpi-card-teal {
  --kpi-accent: #0d9488;
  --kpi-accent-soft: rgba(13, 148, 136, 0.12);
}

.kpi-card-amber {
  --kpi-accent: #d97706;
  --kpi-accent-soft: rgba(217, 119, 6, 0.12);
}

.kpi-card-top {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin-bottom: 0.85rem;
}

.kpi-card-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--kpi-accent-soft);
  color: var(--kpi-accent);
  font-size: 0.95rem;
  flex-shrink: 0;
}

.kpi-card-title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--color-text-muted);
}

.kpi-card-value {
  margin: 0;
  font-size: clamp(1.7rem, 2.4vw, 2.05rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  color: var(--color-navy-dark);
  line-height: 1.15;
}

.kpi-card-skeleton {
  width: 58%;
  height: 1.85rem;
  border-radius: 8px;
  background: linear-gradient(90deg, #e8ecf8 0%, #f7f8fd 50%, #e8ecf8 100%);
  background-size: 200% 100%;
  animation: kpi-shimmer 1.2s ease-in-out infinite;
}

.kpi-card-footer {
  margin: auto 0 0;
  padding-top: 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

@keyframes kpi-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

@media (max-width: 991px) {
  .kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .kpi-card {
    min-height: 0;
  }
}

/*Dashboard*/

.navbar {
  background-color: transparent;
  padding: 0;
}

.navbar-nav .nav-link {
  margin-right: 10px;
  margin-left: 10px;
}

.chart-card,
#chartCard {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.dashboard-title {
  color: var(--color-navy-dark);
  text-align: center;
  font-size: clamp(1.35rem, 2.5vw, 1.75rem);
  font-weight: 700;
  margin-bottom: 1.25rem;
}

.dashboard-chart-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.25rem;
}

.dashboard-chart-header h2 {
  margin: 0 0 0.3rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--color-navy-dark);
}

.dashboard-chart-header p {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.95rem;
}

.dashboard-chart-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: rgba(59, 108, 244, 0.12);
  color: var(--color-primary);
  font-size: 1.05rem;
  flex-shrink: 0;
}

.dashboard-chart-icon-week {
  background: rgba(59, 108, 244, 0.12);
  color: #3b6cf4;
}

.dashboard-chart-icon-month {
  background: rgba(13, 148, 136, 0.12);
  color: #0d9488;
}

.dashboard-chart-icon-code {
  background: rgba(217, 119, 6, 0.12);
  color: #d97706;
}

.dashboard-year-pills {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin: 0.25rem 0 1.15rem;
}

.dashboard-year-pill {
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  color: var(--color-text-muted);
  border-radius: 999px;
  padding: 0.45rem 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.dashboard-year-pill:hover {
  border-color: var(--color-primary);
  color: var(--color-primary);
}

.dashboard-year-pill-active {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: #ffffff;
}

.dashboard-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  margin-bottom: 1rem;
}

.dashboard-table {
  margin-bottom: 0;
  background: var(--color-surface);
}

.dashboard-table thead th {
  background: var(--color-navy-dark);
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.12);
  font-size: 0.85rem;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
}

.dashboard-table tbody td {
  text-align: center;
  vertical-align: middle;
  font-size: 0.9rem;
  color: var(--color-text);
  border-color: var(--color-border);
}

.dashboard-table tbody tr:nth-child(even) {
  background: var(--color-surface-muted);
}

.dashboard-table tbody tr:hover,
.dashboard-table-row-active td {
  background: rgba(59, 108, 244, 0.06);
}

.dashboard-loading-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  text-align: center;
}

.dashboard-loading {
  color: var(--color-text-muted);
  padding: 0.75rem 0 0;
  margin: 0;
  font-weight: 600;
}

.dashboard-loading-spinner {
  width: 28px;
  height: 28px;
  border: 3px solid rgba(59, 108, 244, 0.18);
  border-top-color: var(--color-primary);
  border-radius: 50%;
  animation: dashboard-spin 0.8s linear infinite;
}

@keyframes dashboard-spin {
  to { transform: rotate(360deg); }
}

/*Les deux classes suivantes permettent de centrer le text des labels du treemap*/
.custom-tooltip-treemap {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  min-height: 56px;
  padding: 0.7rem 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: var(--color-text);
  font-weight: 600;
}

.label-treemap {
  display: inline-block;
  vertical-align: middle;
  line-height: 1.4;
  font-size: 0.9rem;
}

@media (max-width: 767px) {
  .dashboard-chart-header {
    flex-direction: column;
  }
}



/*Date picker*/

/*Cookie consent*/

.cookie-consent {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1050;
  padding: 1rem;
  background: #ffffff;
  border-top: 1px solid #d8dce6;
  box-shadow: 0 -4px 16px rgba(0, 0, 51, 0.15);
}

.cookie-consent-content {
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.cookie-consent-text {
  flex: 1 1;
  min-width: 240px;
  margin: 0;
  font-size: 0.95rem;
  color: #333333;
  line-height: 1.5;
}

.cookie-consent-text a {
  color: var(--color-primary);
  font-weight: 500;
}

.cookie-consent-btn {
  min-width: 80px;
  flex-shrink: 0;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;EAC9C,+CAA+C;EAC/C,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,wFAAwF;EACxF,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,uCAAuC;EACvC,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;;EAEE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,iDAAiD;AACnD;;AAEA,gBAAgB;;AAEhB;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,iCAAiC;EACjC,0BAA0B;EAC1B,kDAAkD;EAClD,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,SAAS;IACT,oBAAoB;IACpB,+CAA+C;EACjD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;AACF;;AAEA,gBAAgB;;AAEhB;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,gBAAgB;;AAEhB;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,2CAA2C;EAC3C,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,sCAAsC;EACtC,qCAAqC;EACrC,+BAA+B;EAC/B,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;;AAGA,cAAc;AACd;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE;AACF;;AAEA,eAAe;;AAEf;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,uDAAuD;EACvD,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,4BAA4B;EAC5B,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,mCAAmC;EACnC,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,8BAA8B;EAC9B,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,+BAA+B;EAC/B,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,kCAAkC;EAClC,cAAc;EACd,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,qBAAqB;IACrB,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,gBAAgB;;AAEhB;;EAEE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,8BAA8B;AAChC;;AAEA;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,qCAAqC;EACrC,oBAAoB;EACpB,sCAAsC;EACtC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;;EAEE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,yDAAyD;IACzD,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,+BAA+B;EAC/B,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;;AAGA,YAAY;;AAEZ;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,sCAAsC;EACtC,qCAAqC;EACrC,+BAA+B;EAC/B,uDAAuD;AACzD;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,WAAW;AACb;;AAEA,cAAc;;AAEd;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,YAAY;;AAEZ;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,8BAA8B;EAC9B,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sCAAsC;EACtC,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,iFAAiF;AACjF;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;;;AAIA,cAAc;;AAEd,iBAAiB;;AAEjB;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["/*General*/\n:root {\n  --color-navy: #0a1172;\n  --color-navy-dark: #060b4a;\n  --color-primary: #3b6cf4;\n  --color-primary-hover: #2f58d0;\n  --color-surface: #ffffff;\n  --color-surface-muted: #f4f6fb;\n  --color-border: #e3e8f2;\n  --color-text: #1f2937;\n  --color-text-muted: #5b6478;\n  --shadow-sm: 0 2px 8px rgba(10, 17, 114, 0.08);\n  --shadow-md: 0 8px 24px rgba(10, 17, 114, 0.12);\n  --radius-md: 12px;\n  --radius-lg: 16px;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  background: linear-gradient(180deg, #eef1fb 0%, #e8ecf8 100%);\n}\n\nbody {\n  font-family: 'Inter', 'Rubik', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  color: var(--color-text);\n}\n\n#root {\n  min-height: 100vh;\n}\n\n.app-shell {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.app-main {\n  flex: 1;\n  padding: 1.5rem 0 2.5rem;\n}\n\n.page-container {\n  max-width: 960px;\n}\n\n.page-card,\n.jumbotron {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  padding: 2rem;\n}\n\n.page-card-header {\n  margin-bottom: 1.5rem;\n}\n\n.page-eyebrow {\n  margin: 0 0 0.35rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--color-primary);\n}\n\n.page-card h1,\n.jumbotron .display-4 {\n  font-size: clamp(1.75rem, 3vw, 2.25rem);\n  font-weight: 700;\n  color: var(--color-navy-dark);\n  margin-bottom: 0.75rem;\n}\n\n.page-lead,\n.jumbotron .lead {\n  color: var(--color-text-muted);\n  font-size: 1.05rem;\n  line-height: 1.6;\n}\n\n.btn-primary {\n  background-color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.btn-primary:hover,\n.btn-primary:focus {\n  background-color: var(--color-primary-hover);\n  border-color: var(--color-primary-hover);\n}\n\n.btn-outline-primary {\n  color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.btn-outline-primary:hover {\n  background-color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.form-control:focus {\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 0.2rem rgba(59, 108, 244, 0.15);\n}\n\n/* Site header */\n\n.site-header {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  background: rgba(6, 11, 74, 0.96);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: var(--shadow-sm);\n}\n\n.site-header-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 68px;\n}\n\n.site-header-top {\n  display: contents;\n}\n\n.site-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.65rem;\n  color: #ffffff;\n  text-decoration: none;\n  font-weight: 700;\n  font-size: 1.2rem;\n  flex-shrink: 0;\n}\n\n.site-brand:hover {\n  color: #ffffff;\n  text-decoration: none;\n  opacity: 0.92;\n}\n\n.site-brand-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.site-nav-toggle {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  border-radius: 8px;\n  padding: 0.35rem 0.55rem;\n  background: transparent;\n  cursor: pointer;\n}\n\n.site-nav {\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n}\n\n.site-nav-links {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.site-nav-link {\n  color: rgba(255, 255, 255, 0.88);\n  text-decoration: none;\n  padding: 0.5rem 0.85rem;\n  border-radius: 8px;\n  font-weight: 500;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.site-nav-link:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.1);\n  text-decoration: none;\n}\n\n.site-nav-link-active {\n  color: #ffffff;\n  background: rgba(59, 108, 244, 0.35);\n}\n\n.site-nav-logout {\n  margin-left: 0.75rem;\n  padding: 0.45rem 0.9rem;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  border-radius: 8px;\n  background: transparent;\n  color: #ffffff;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.site-nav-logout:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n@media (max-width: 767px) {\n  .site-header-inner {\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: flex-start;\n    min-height: 68px;\n  }\n\n  .site-header-top {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 68px;\n    flex-shrink: 0;\n  }\n\n  .site-nav-toggle {\n    display: inline-flex;\n    flex-shrink: 0;\n  }\n\n  .site-nav {\n    display: none;\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n    margin: 0;\n    padding-top: 0.75rem;\n    border-top: 1px solid rgba(255, 255, 255, 0.12);\n  }\n\n  .site-nav.site-nav-open {\n    display: flex;\n  }\n\n  .site-nav-links {\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n  }\n\n  .site-nav-link {\n    text-align: left;\n  }\n\n  .site-nav-logout {\n    margin: 0.75rem 0 1.25rem;\n    width: 100%;\n  }\n}\n\n/* Site footer */\n\n.site-footer {\n  margin-top: auto;\n  background: var(--color-navy-dark);\n  color: rgba(255, 255, 255, 0.85);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.site-footer-inner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 0.5rem;\n  min-height: 96px;\n  padding: 1.25rem 0;\n}\n\n.site-footer-logo {\n  font-weight: 600;\n}\n\n.site-footer-copy {\n  font-size: 0.875rem;\n  color: rgba(255, 255, 255, 0.65);\n}\n\n.site-footer-nav {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1rem 1.5rem;\n}\n\n.site-footer-nav a {\n  color: rgba(255, 255, 255, 0.9);\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.site-footer-nav a:hover {\n  color: #ffffff;\n  text-decoration: underline;\n}\n\n/* Legal pages */\n\n.legal-page section {\n  margin-bottom: 1.75rem;\n}\n\n.legal-page h2 {\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: var(--color-navy-dark);\n  margin-bottom: 0.75rem;\n}\n\n.legal-page p,\n.legal-page li {\n  color: var(--color-text-muted);\n  line-height: 1.7;\n}\n\n.legal-page ul {\n  padding-left: 1.25rem;\n}\n\n.legal-page a {\n  color: var(--color-primary);\n  font-weight: 500;\n}\n\n.legal-page a.btn-primary,\n.legal-page a.btn-primary:hover,\n.legal-page a.btn-primary:focus,\n.legal-page a.btn-outline-primary:hover,\n.legal-page a.btn-outline-primary:focus {\n  color: #ffffff;\n}\n\n.contact-form {\n  max-width: 36rem;\n}\n\n.contact-message {\n  min-height: 10rem;\n  resize: vertical;\n}\n\n.contact-honeypot {\n  position: absolute;\n  left: -9999px;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n\n.legal-page-footer {\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.about-callout {\n  background: var(--color-surface-muted);\n  border: 1px solid var(--color-border);\n  border-left: 4px solid var(--color-primary);\n  border-radius: var(--radius-md);\n  padding: 1.25rem 1.4rem;\n  margin-bottom: 1.75rem;\n}\n\n.about-callout h2 {\n  margin-top: 0;\n}\n\n.about-callout p:last-child {\n  margin-bottom: 0;\n}\n\n.about-highlights {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n}\n\n@media (min-width: 768px) {\n  .about-highlights {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.about-highlights .home-feature-item {\n  height: 100%;\n}\n\n.about-steps {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  counter-reset: about-step;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.about-steps li {\n  position: relative;\n  padding: 1rem 1.15rem 1rem 3.35rem;\n  background: var(--color-surface-muted);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  color: var(--color-text-muted);\n  line-height: 1.65;\n}\n\n.about-steps li::before {\n  counter-increment: about-step;\n  content: counter(about-step);\n  position: absolute;\n  left: 0.9rem;\n  top: 1rem;\n  width: 1.7rem;\n  height: 1.7rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: rgba(59, 108, 244, 0.12);\n  color: var(--color-primary);\n  font-weight: 700;\n  font-size: 0.9rem;\n}\n\n.about-steps strong {\n  color: var(--color-navy-dark);\n}\n\n.about-faq h3 {\n  font-size: 1.02rem;\n  font-weight: 600;\n  color: var(--color-navy-dark);\n  margin: 1.35rem 0 0.45rem;\n}\n\n.about-cta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.about-cta .btn {\n  margin-bottom: 0;\n}\n\n.about-cta-note {\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n\n/*Transaction*/\n#validtype {\n  display: flex;\n  justify-content: center;\n}\n\n#transac_list {\n  background-color: #F0F0F0\n}\n\n/* Historique */\n\n.historique-calendar-card {\n  text-align: center;\n}\n\n.historique-calendar-wrap {\n  display: flex;\n  justify-content: center;\n}\n\n.historique-calendar-wrap .rdp-root {\n  --rdp-accent-color: var(--color-primary);\n  --rdp-accent-background-color: rgba(59, 108, 244, 0.12);\n  --rdp-day-height: 42px;\n  --rdp-day-width: 42px;\n  --rdp-day_button-height: 40px;\n  --rdp-day_button-width: 40px;\n  --rdp-selected-border: 2px solid var(--color-primary);\n}\n\n.historique-week-selected .rdp-day_button {\n  background: rgba(59, 108, 244, 0.18);\n  color: var(--color-navy-dark);\n  font-weight: 600;\n}\n\n.historique-calendar-wrap .rdp-selected .rdp-day_button {\n  background: transparent;\n  color: inherit;\n  font-weight: inherit;\n  border: none;\n}\n\n.historique-week-label {\n  margin: 1rem 0 0;\n  padding: 0.65rem 1rem;\n  display: inline-block;\n  border-radius: 999px;\n  background: rgba(59, 108, 244, 0.1);\n  color: var(--color-navy-dark);\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.historique-view-toggle {\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n  margin: 1.25rem 0;\n  flex-wrap: wrap;\n}\n\n.historique-view-btn {\n  border: 1px solid var(--color-border);\n  background: var(--color-surface);\n  color: var(--color-text-muted);\n  border-radius: 999px;\n  padding: 0.55rem 1.15rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.historique-view-btn:hover {\n  border-color: var(--color-primary);\n  color: var(--color-primary);\n}\n\n.historique-view-btn-active {\n  background: var(--color-primary);\n  border-color: var(--color-primary);\n  color: #ffffff;\n}\n\n.historique-report-card {\n  padding: 1.25rem;\n}\n\n.historique-report-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n}\n\n.historique-total-badge {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  padding: 0.65rem 0.9rem;\n  border-radius: var(--radius-md);\n  background: rgba(59, 108, 244, 0.08);\n  border: 1px solid rgba(59, 108, 244, 0.18);\n}\n\n.historique-total-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--color-text-muted);\n}\n\n.historique-total-value {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--color-navy-dark);\n}\n\n.historique-table-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n}\n\n.historique-table {\n  margin-bottom: 0;\n  background: var(--color-surface);\n}\n\n.historique-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: var(--color-navy-dark);\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.12);\n  white-space: nowrap;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.historique-table tbody td {\n  vertical-align: middle;\n  font-size: 0.9rem;\n  color: var(--color-text);\n  border-color: var(--color-border);\n}\n\n.historique-table tbody tr:nth-child(even) {\n  background: var(--color-surface-muted);\n}\n\n.historique-table tbody tr:hover {\n  background: rgba(59, 108, 244, 0.06);\n}\n\n.historique-table tfoot td {\n  background: var(--color-surface-muted);\n  font-weight: 600;\n  border-top: 2px solid var(--color-border);\n}\n\n.historique-notes-cell {\n  max-width: 180px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.historique-delete-btn {\n  padding: 0.2rem 0.45rem;\n}\n\n.historique-empty-state {\n  text-align: center;\n  padding: 2.5rem 1rem;\n  color: var(--color-text-muted);\n}\n\n.historique-empty-icon {\n  display: block;\n  font-size: 2rem;\n  margin-bottom: 0.75rem;\n  color: var(--color-primary);\n}\n\n.historique-loading {\n  margin: 0;\n  padding: 2rem 0;\n  text-align: center;\n}\n\n@media (max-width: 767px) {\n  .historique-calendar-wrap .rdp-root {\n    --rdp-day-height: 36px;\n    --rdp-day-width: 36px;\n    --rdp-day_button-height: 34px;\n    --rdp-day_button-width: 34px;\n  }\n\n  .historique-report-header {\n    flex-direction: column;\n  }\n\n  .historique-total-badge {\n    align-items: flex-start;\n  }\n}\n\n/* Transaction */\n\n.transaction-page,\n.historique-page {\n  max-width: 1100px;\n  padding-bottom: 1rem;\n}\n\n.transaction-header,\n.historique-header {\n  margin-bottom: 1.75rem;\n}\n\n.transaction-subtitle,\n.historique-subtitle {\n  margin: 0;\n  color: var(--color-text-muted);\n}\n\n.transaction-section-title,\n.historique-section-title {\n  margin: 0 0 0.35rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--color-navy-dark);\n}\n\n.transaction-section-heading {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.35rem;\n}\n\n.transaction-section-heading .transaction-section-title {\n  margin: 0;\n}\n\n.transaction-help-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.55rem;\n  height: 1.55rem;\n  padding: 0;\n  border: 1px solid var(--color-border);\n  border-radius: 999px;\n  background: var(--color-surface-muted);\n  color: var(--color-primary);\n  font-size: 0.85rem;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.transaction-help-btn:hover,\n.transaction-help-btn:focus {\n  background: rgba(59, 108, 244, 0.12);\n  border-color: var(--color-primary);\n  outline: none;\n}\n\n.shortcut-help-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem;\n  background: rgba(6, 11, 74, 0.45);\n}\n\n.shortcut-help-dialog {\n  width: min(640px, 100%);\n  max-height: min(80vh, 720px);\n  display: flex;\n  flex-direction: column;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  padding: 1.25rem 1.35rem 1.35rem;\n}\n\n.shortcut-help-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.shortcut-help-header h3 {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: var(--color-navy-dark);\n}\n\n.shortcut-help-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  background: transparent;\n  color: var(--color-text-muted);\n  cursor: pointer;\n}\n\n.shortcut-help-close:hover {\n  background: var(--color-surface-muted);\n  color: var(--color-navy-dark);\n}\n\n.shortcut-help-status,\n.shortcut-help-error {\n  margin: 0;\n  color: var(--color-text-muted);\n}\n\n.shortcut-help-error {\n  color: #b91c1c;\n}\n\n.shortcut-help-table-wrap {\n  overflow: auto;\n}\n\n.transaction-section-hint,\n.historique-section-hint {\n  margin: 0 0 1.25rem;\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n}\n\n.transaction-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n\n.transaction-form-card {\n  height: 100%;\n  margin-bottom: 0;\n}\n\n.transaction-form-card-wide {\n  margin-bottom: 1.25rem;\n}\n\n.transaction-input-row {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 0.75rem;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.transaction-input-row-no-status {\n  grid-template-columns: 1fr auto;\n}\n\n.transaction-status-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 999px;\n  font-size: 1.1rem;\n}\n\n.transaction-status-icon-valid {\n  color: #15803d;\n  background: rgba(21, 128, 61, 0.1);\n}\n\n.transaction-status-icon-invalid {\n  color: #b91c1c;\n  background: rgba(185, 28, 28, 0.08);\n}\n\n.transaction-desc-preview {\n  margin-bottom: 0.75rem;\n  background: var(--color-surface-muted);\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n}\n\n.transaction-field {\n  margin-bottom: 1rem;\n}\n\n.transaction-field label {\n  display: block;\n  margin-bottom: 0.35rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--color-navy-dark);\n}\n\n.transaction-field-inline {\n  max-width: 180px;\n}\n\n.transaction-field-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.transaction-field-full {\n  grid-column: 1 / -1;\n}\n\n.transaction-code-fields {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.transaction-code-line {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  min-width: 0;\n}\n\n.transaction-code-line .transaction-code-input {\n  flex: 1;\n  min-width: 0;\n}\n\n.transaction-code-line-no-status .transaction-code-input {\n  width: 100%;\n}\n\n.transaction-modif-select {\n  width: 100%;\n  min-width: 0;\n}\n\n@media (min-width: 992px) {\n  .transaction-code-fields {\n    grid-template-columns: minmax(0, 1fr) minmax(160px, auto);\n    align-items: center;\n  }\n\n  .transaction-modif-select {\n    width: auto;\n    min-width: 160px;\n  }\n}\n\n.transaction-qte-input,\n.transaction-code-input {\n  max-width: 140px;\n}\n\n.transaction-success-banner {\n  margin-bottom: 1rem;\n  padding: 0.65rem 0.85rem;\n  border-radius: var(--radius-md);\n  background: rgba(21, 128, 61, 0.1);\n  border: 1px solid rgba(21, 128, 61, 0.2);\n  color: #166534;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.transaction-submit-row {\n  display: flex;\n  justify-content: center;\n  padding-top: 0.25rem;\n}\n\n.transaction-loading {\n  text-align: center;\n  padding: 2rem 0;\n}\n\n@media (max-width: 991px) {\n  .transaction-form-grid,\n  .transaction-field-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .transaction-input-row {\n    grid-template-columns: auto 1fr;\n  }\n\n  .transaction-input-row-no-status {\n    grid-template-columns: 1fr;\n  }\n\n  .transaction-input-row-no-status .transaction-modif-select,\n  .transaction-input-row .transaction-modif-select,\n  .transaction-input-row #inputModif {\n    grid-column: 1 / -1;\n  }\n\n  .transaction-qte-input,\n  .transaction-code-input,\n  .transaction-field-inline {\n    max-width: none;\n  }\n\n  .transaction-input-row .transaction-qte-input {\n    grid-column: 1 / -1;\n  }\n}\n\n\n/*Auth page*/\n\n.auth-actions-box {\n  width: 100%;\n  max-width: 320px;\n  padding: 1.75rem;\n  background: var(--color-surface-muted);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n}\n\n.auth-actions-box-secondary {\n  margin-top: 1.5rem;\n  background: #f8f9fc;\n}\n\n.auth-actions-title {\n  font-size: 1.35rem;\n  font-weight: 600;\n  color: var(--color-navy-dark);\n  margin-bottom: 0.5rem;\n  text-align: center;\n}\n\n.auth-actions-subtitle {\n  font-size: 0.95rem;\n  color: #5a6275;\n  text-align: center;\n  margin-bottom: 1.25rem;\n}\n\n.auth-actions-btn {\n  margin-bottom: 0.75rem;\n}\n\n.auth-actions-btn:last-child {\n  margin-bottom: 0;\n}\n\n.auth-actions-link {\n  display: block;\n  width: 100%;\n  margin-top: 0.5rem;\n  padding: 0.25rem 0;\n  font-size: 0.9rem;\n  color: #000066;\n  text-align: center;\n  text-decoration: none;\n}\n\n.auth-actions-link:hover {\n  color: #4688F4;\n  text-decoration: underline;\n}\n\n.auth-footer-links {\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e2e6ef;\n  text-align: center;\n}\n\n.auth-footer-links p {\n  margin-bottom: 0.5rem;\n  font-size: 0.95rem;\n  color: #5a6275;\n}\n\n.auth-footer-links p:last-child {\n  margin-bottom: 0;\n}\n\n.auth-footer-links a {\n  color: #000066;\n  font-weight: 500;\n}\n\n.auth-footer-links a:hover {\n  color: #4688F4;\n}\n\n.auth-inline-link {\n  font-size: 0.9rem;\n  color: #000066;\n  font-weight: 500;\n}\n\n.auth-inline-link:hover {\n  color: #4688F4;\n}\n\n#logbutton {\n  color: rgb(255, 255, 255);\n  background-color: #4688F4;\n  text-align: center;\n  text-decoration: none;\n  height: 37px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: 16px;\n  padding-left: 16px;\n  border: none;\n  cursor: pointer;\n}\n\n.auth-form .form-group {\n  margin-bottom: 1rem;\n}\n\n#btnbox {\n  min-height: 25vh;\n  display: flex;\n  background: transparent;\n  justify-content: center;\n  box-shadow: none;\n  border: none;\n  padding: 0;\n}\n\n.home-landing {\n  padding: 2rem;\n}\n\n.home-landing-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.home-landing-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  margin-bottom: 0.75rem;\n  border-radius: 14px;\n  background: rgba(59, 108, 244, 0.12);\n  color: var(--color-primary);\n  font-size: 1.5rem;\n}\n\n.home-landing-header h1 {\n  margin: 0;\n  font-size: clamp(2rem, 4vw, 2.75rem);\n  font-weight: 700;\n  color: var(--color-navy-dark);\n}\n\n.home-landing-lead {\n  max-width: 36rem;\n  margin: 0.85rem 0 0;\n  font-size: 1.15rem;\n  font-weight: 600;\n  line-height: 1.5;\n  color: var(--color-navy);\n}\n\n.home-landing-sublead {\n  max-width: 38rem;\n  margin: 0.5rem 0 0;\n  font-size: 1.02rem;\n  line-height: 1.6;\n  color: var(--color-text-muted);\n}\n\n.home-landing-auth {\n  margin-bottom: 0;\n}\n\n.home-landing-features {\n  margin-top: 0;\n}\n\n@media (max-width: 991px) {\n  .home-landing-features {\n    margin-top: 2rem;\n  }\n\n  .auth-actions-box {\n    max-width: 100%;\n  }\n}\n\n@media (min-width: 992px) {\n  .home-landing-content {\n    align-items: center;\n  }\n\n  .home-landing-features {\n    padding-right: 1rem;\n  }\n\n  .home-landing-auth {\n    padding-left: 1rem;\n  }\n}\n\n.home-features {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.home-feature-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 1.1rem 1.15rem;\n  background: var(--color-surface-muted);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  transition: box-shadow 0.15s ease, transform 0.15s ease;\n}\n\n.home-feature-item:hover {\n  box-shadow: var(--shadow-sm);\n  transform: translateY(-1px);\n}\n\n.home-feature-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  background: rgba(59, 108, 244, 0.12);\n  color: var(--color-primary);\n  font-size: 1.1rem;\n}\n\n.home-feature-content h3 {\n  margin: 0 0 0.35rem;\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: var(--color-navy-dark);\n  font-family: inherit;\n}\n\n.home-feature-content p {\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.55;\n  color: var(--color-text-muted);\n  font-family: inherit;\n}\n\n#logoGoogle {\n  background-color: rgb(255, 255, 255);\n  display: flex;\n  float: left;\n}\n\n/* Home KPIs */\n\n.home-dashboard-page,\n.dashboard-page {\n  max-width: 1180px;\n}\n\n.home-dashboard-header,\n.dashboard-page-header {\n  margin-bottom: 1.75rem;\n}\n\n.home-dashboard-header h1,\n.dashboard-page-header h1 {\n  margin: 0 0 0.4rem;\n  font-size: clamp(1.85rem, 3vw, 2.35rem);\n  font-weight: 700;\n  color: var(--color-navy-dark);\n}\n\n.home-dashboard-header .page-lead,\n.dashboard-page-header .page-lead {\n  margin: 0;\n}\n\n.home-kpi-section {\n  margin-bottom: 2rem;\n}\n\n.home-kpi-section-head {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  margin-bottom: 1rem;\n}\n\n.home-kpi-section-head h2 {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: var(--color-navy-dark);\n}\n\n.home-kpi-section-head p {\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 0.95rem;\n}\n\n.kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.kpi-card {\n  position: relative;\n  overflow: hidden;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  padding: 1.15rem 1.2rem 1.2rem;\n  min-height: 154px;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.kpi-card::before {\n  content: '';\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 4px;\n  background: var(--kpi-accent);\n}\n\n.kpi-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.kpi-card-blue {\n  --kpi-accent: #3b6cf4;\n  --kpi-accent-soft: rgba(59, 108, 244, 0.12);\n}\n\n.kpi-card-indigo {\n  --kpi-accent: #4f46e5;\n  --kpi-accent-soft: rgba(79, 70, 229, 0.12);\n}\n\n.kpi-card-teal {\n  --kpi-accent: #0d9488;\n  --kpi-accent-soft: rgba(13, 148, 136, 0.12);\n}\n\n.kpi-card-amber {\n  --kpi-accent: #d97706;\n  --kpi-accent-soft: rgba(217, 119, 6, 0.12);\n}\n\n.kpi-card-top {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  margin-bottom: 0.85rem;\n}\n\n.kpi-card-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: var(--kpi-accent-soft);\n  color: var(--kpi-accent);\n  font-size: 0.95rem;\n  flex-shrink: 0;\n}\n\n.kpi-card-title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--color-text-muted);\n}\n\n.kpi-card-value {\n  margin: 0;\n  font-size: clamp(1.7rem, 2.4vw, 2.05rem);\n  font-weight: 700;\n  letter-spacing: -0.03em;\n  color: var(--color-navy-dark);\n  line-height: 1.15;\n}\n\n.kpi-card-skeleton {\n  width: 58%;\n  height: 1.85rem;\n  border-radius: 8px;\n  background: linear-gradient(90deg, #e8ecf8 0%, #f7f8fd 50%, #e8ecf8 100%);\n  background-size: 200% 100%;\n  animation: kpi-shimmer 1.2s ease-in-out infinite;\n}\n\n.kpi-card-footer {\n  margin: auto 0 0;\n  padding-top: 0.75rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--color-text-muted);\n}\n\n@keyframes kpi-shimmer {\n  0% { background-position: 100% 0; }\n  100% { background-position: -100% 0; }\n}\n\n@media (max-width: 991px) {\n  .kpi-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .kpi-card {\n    min-height: 0;\n  }\n}\n\n/*Dashboard*/\n\n.navbar {\n  background-color: transparent;\n  padding: 0;\n}\n\n.navbar-nav .nav-link {\n  margin-right: 10px;\n  margin-left: 10px;\n}\n\n.chart-card,\n#chartCard {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.dashboard-title {\n  color: var(--color-navy-dark);\n  text-align: center;\n  font-size: clamp(1.35rem, 2.5vw, 1.75rem);\n  font-weight: 700;\n  margin-bottom: 1.25rem;\n}\n\n.dashboard-chart-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1.25rem;\n}\n\n.dashboard-chart-header h2 {\n  margin: 0 0 0.3rem;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--color-navy-dark);\n}\n\n.dashboard-chart-header p {\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 0.95rem;\n}\n\n.dashboard-chart-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  background: rgba(59, 108, 244, 0.12);\n  color: var(--color-primary);\n  font-size: 1.05rem;\n  flex-shrink: 0;\n}\n\n.dashboard-chart-icon-week {\n  background: rgba(59, 108, 244, 0.12);\n  color: #3b6cf4;\n}\n\n.dashboard-chart-icon-month {\n  background: rgba(13, 148, 136, 0.12);\n  color: #0d9488;\n}\n\n.dashboard-chart-icon-code {\n  background: rgba(217, 119, 6, 0.12);\n  color: #d97706;\n}\n\n.dashboard-year-pills {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.5rem;\n  margin: 0.25rem 0 1.15rem;\n}\n\n.dashboard-year-pill {\n  border: 1px solid var(--color-border);\n  background: var(--color-surface);\n  color: var(--color-text-muted);\n  border-radius: 999px;\n  padding: 0.45rem 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.dashboard-year-pill:hover {\n  border-color: var(--color-primary);\n  color: var(--color-primary);\n}\n\n.dashboard-year-pill-active {\n  background: var(--color-primary);\n  border-color: var(--color-primary);\n  color: #ffffff;\n}\n\n.dashboard-table-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  margin-bottom: 1rem;\n}\n\n.dashboard-table {\n  margin-bottom: 0;\n  background: var(--color-surface);\n}\n\n.dashboard-table thead th {\n  background: var(--color-navy-dark);\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.12);\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.dashboard-table tbody td {\n  text-align: center;\n  vertical-align: middle;\n  font-size: 0.9rem;\n  color: var(--color-text);\n  border-color: var(--color-border);\n}\n\n.dashboard-table tbody tr:nth-child(even) {\n  background: var(--color-surface-muted);\n}\n\n.dashboard-table tbody tr:hover,\n.dashboard-table-row-active td {\n  background: rgba(59, 108, 244, 0.06);\n}\n\n.dashboard-loading-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 240px;\n  text-align: center;\n}\n\n.dashboard-loading {\n  color: var(--color-text-muted);\n  padding: 0.75rem 0 0;\n  margin: 0;\n  font-weight: 600;\n}\n\n.dashboard-loading-spinner {\n  width: 28px;\n  height: 28px;\n  border: 3px solid rgba(59, 108, 244, 0.18);\n  border-top-color: var(--color-primary);\n  border-radius: 50%;\n  animation: dashboard-spin 0.8s linear infinite;\n}\n\n@keyframes dashboard-spin {\n  to { transform: rotate(360deg); }\n}\n\n/*Les deux classes suivantes permettent de centrer le text des labels du treemap*/\n.custom-tooltip-treemap {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-md);\n  min-height: 56px;\n  padding: 0.7rem 0.95rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: var(--color-text);\n  font-weight: 600;\n}\n\n.label-treemap {\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 1.4;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 767px) {\n  .dashboard-chart-header {\n    flex-direction: column;\n  }\n}\n\n\n\n/*Date picker*/\n\n/*Cookie consent*/\n\n.cookie-consent {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1050;\n  padding: 1rem;\n  background: #ffffff;\n  border-top: 1px solid #d8dce6;\n  box-shadow: 0 -4px 16px rgba(0, 0, 51, 0.15);\n}\n\n.cookie-consent-content {\n  max-width: 960px;\n  margin: 0 auto;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.cookie-consent-text {\n  flex: 1;\n  min-width: 240px;\n  margin: 0;\n  font-size: 0.95rem;\n  color: #333333;\n  line-height: 1.5;\n}\n\n.cookie-consent-text a {\n  color: var(--color-primary);\n  font-weight: 500;\n}\n\n.cookie-consent-btn {\n  min-width: 80px;\n  flex-shrink: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
